'use client'

import { animateNav } from '@/animations/nav/animateNav'
import { useGSAPContext } from '@/hooks'
import { cn } from '@/lib/utils'
import { useStoreNavigation } from '@/store'
import { Typo3_834 } from '@/types'
import { memo, useEffect, useEffectEvent, useRef, useState } from 'react'
import NavDesktop from './Nav/NavDesktop'
import NavMobile from './Nav/NavMobile'

interface Props {
  data: Typo3_834
}

const BottomBar = ({ data }: Props) => {
  const comp = useRef(null)
  const tlDesktop = useRef<GSAPTimeline | null>(null)
  const tlMobile = useRef<GSAPTimeline | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)

  const { isNavOpen } = useStoreNavigation()

  useGSAPContext({
    scope: comp,
    callback() {
      animateNav(comp, tlDesktop, 'desktop')
      animateNav(comp, tlMobile, 'mobile')
    }
  })

  useEffect(() => {
    if (!tlDesktop.current || !tlMobile.current) {
      return
    }

    if (isNavOpen === true) {
      tlMobile.current?.timeScale(1).play()
      tlDesktop.current?.timeScale(1).play()
    } else {
      tlMobile.current?.timeScale(2).reverse()
      tlDesktop.current?.timeScale(2).reverse()
    }
  }, [isNavOpen])

  const handleSetIsLoaded = useEffectEvent(() => {
    setIsLoaded(true)
  })

  useEffect(() => {
    handleSetIsLoaded()
  }, [])

  return (
    <div
      ref={comp}
      className={cn(
        'c-bottom-bar absolute top-0 right-0 left-0 grid grid-cols-1 grid-rows-[auto_1fr] items-center pt-[calc(var(--spacing-sm)*3+var(--logo-header-height))]',
        !isLoaded && 'hidden'
      )}
    >
      <div className="relative z-20 max-h-[calc(100dvh-var(--logo-header-height)-var(--spacing-xs)*4)] w-full max-lg:overflow-y-auto">
        <div className="p-xs h-full max-lg:hidden lg:block">
          <NavDesktop data-nav-menu-desktop data={data.navigation} />
        </div>
        <div data-lenis-prevent className="p-xs lg:hidden">
          <NavMobile data-nav-menu-mobile data={data.navigation} />
        </div>
      </div>
    </div>
  )
}

export default memo(BottomBar)
